import React, { MouseEventHandler, ReactNode, useCallback } from 'react';

import withNoScrollOnActive from '../../../hocs/withNoScrollOnActive';
import Icon from '../../assets/icons';

import { ModalContainer, ModalCrossWrapper, ModalTitle, StyledModal } from './styles';

export interface IModalProps {
  isActive?: boolean;
  onClose?: () => void;
  children: ReactNode;
  title: string;
}

function Modal({ isActive, onClose, children, title }: IModalProps) {
  const handleClick: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <ModalContainer
      $isActive={isActive}
      onClick={onClose}
    >
      <StyledModal
        $isActive={isActive}
        onClick={handleClick}
      >
        <ModalTitle>{title}</ModalTitle>

        <ModalCrossWrapper onClick={onClose}>
          <Icon variant="cross" />
        </ModalCrossWrapper>

        {children}
      </StyledModal>
    </ModalContainer>
  );
}

export default withNoScrollOnActive(Modal);
